import { useState } from 'react'

import { Box, Icon, Tag, Text, Touchable } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const GenerateDraftDescriptionMessage = () => {
  const [showMessage, setShowMessage] = useState<boolean>(true)

  if (!showMessage) {
    return null
  }
  return (
    <Box
      background="viridian100"
      paddingY="s16"
      paddingX="s24"
      gap="s8"
      borderRadius={{ all: 'abs008' }}
    >
      <Box flexDirection="row" justifyContent="spaceBetween" gap="s8">
        <Tag inline icon="ai" leftItem="icon" type="viridian" solid>
          <strong>
            {i18n.t('ats.job_posting_settings.description.generate_draft.experimental')}
          </strong>{' '}
          {i18n.t('ats.job_posting_settings.description.generate_draft.info_quality')}
        </Tag>
        <Touchable onClick={() => setShowMessage(false)}>
          <Icon.Small icon="close" color="grey800" />
        </Touchable>
      </Box>
      <Text.Normal>
        {i18n.t('ats.job_posting_settings.description.generate_draft.warning')}
      </Text.Normal>
    </Box>
  )
}
